import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  OnDestroy,
  OnChanges,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TextKeyConstants } from 'src/app/models/Constants';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'cell-validation',
  templateUrl: './cell-validation.component.html',
  styleUrl: './cell-validation.component.scss',
})
export class CellValidationComponent implements OnInit, OnChanges, OnDestroy {
  isInitialised = false;
  OptInOptOutInfo = '';
  CellPhoneInfo = '';
  isShowOTPModal = false;
  isCellVerified = false;
  cellPhoneNumber = '';
  isCellPhoneNumberValid = false;
  cellPhoneForm: FormGroup = new FormGroup({});
  subscriptions: Subscription = new Subscription();
  @Input() pageName = '';
  @Input() originalCellPhoneNumber = '';
  @Input() isAllowEdit: boolean = false;
  @Input() optInStatus: boolean = false;
  @Output() cellValidation: EventEmitter<string> = new EventEmitter<string>();
  @Output() optInOptOut: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cellVerification: EventEmitter<object> = new EventEmitter<object>();
  cellPhoneNumberPattern = new RegExp(/^\d{3}-\d{3}-\d{4}$/);
  componentClasses: { [key: string]: string } = {
    form: '',
    inputdiv: '',
    input: '',
    radio: '',
  };
  @Input() isShowOnDisabledState = false;
  classes = {
    item1: 'row',
    item2: 'n-form-control w370 d-block',
    item3: 'col-6 n-input-group',
    item4: 'n-form-control w350 d-block',
    item5: 'col-4 n-input-group',
  };
  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly generalService: GeneralService,
  ) {
    this.subscriptions.add(
      this.generalService.textMessageArr.subscribe(() => {
        this.CellPhoneInfo = this.generalService?.GetTextMessage(
          TextKeyConstants.CellPhoneInfo,
        );
        this.OptInOptOutInfo = this.generalService?.GetTextMessage(
          TextKeyConstants.OptInOptOutInfo,
        );
      }),
    );
  }

  ngOnChanges(changes: any): void {
    if (
      this.originalCellPhoneNumber !== null ||
      this.originalCellPhoneNumber !== ''
    ) {
      this.originalCellPhoneNumber = this.cellPhoneFormatter(
        this.originalCellPhoneNumber,
      );
    }
    if (changes.isAllowEdit && this.isInitialised) {
      this.SetCellPhoneForm();
    }
  }

  ngOnInit(): void {
    this.cellPhoneForm = new FormGroup({
      cellPhoneNumber: new FormControl(null, [Validators.maxLength(12)]),
      isOptInForCommunication: new FormControl(
        { value: null, disabled: true },
        [],
      ),
    });

    this.cellPhoneForm.controls['cellPhoneNumber'].valueChanges.subscribe(
      (value) => {
        if (
          this.originalCellPhoneNumber !== null &&
          this.originalCellPhoneNumber !== ''
        ) {
          if (this.originalCellPhoneNumber !== value) {
            this.SetValueForCommunication(value);
          } else {
            this.CheckCellPhoneNumberValidation(value);
            this.CheckInValidCellPhoneNumber();
            this.isCellVerified = true;
            this.cellPhoneForm
              .get('isOptInForCommunication')
              ?.setValue(this.optInStatus);
            this.cellPhoneForm.get('isOptInForCommunication')?.enable();
            this.cellVerification.emit({
              phoneHash: '',
              isValid: true,
            });
          }
        } else {
          this.SetValueForCommunication(value);
        }
        this.cellValidation.emit(value);
      },
    );

    this.cellPhoneForm.controls[
      'isOptInForCommunication'
    ].valueChanges.subscribe((value) => {
      this.optInOptOut.emit(value);
    });

    this.SetCellPhoneForm();

    this.GetCellPhoneInfos();
    this.isInitialised = true;
  }

  SetCellPhoneForm() {
    this.cellPhoneForm.controls['cellPhoneNumber'].setValue(
      this.originalCellPhoneNumber,
    );
    this.cellPhoneForm.controls['cellPhoneNumber'].updateValueAndValidity();

    if (
      this.originalCellPhoneNumber != null &&
      this.originalCellPhoneNumber != ''
    ) {
      this.isCellVerified = true;
      this.isCellPhoneNumberValid = true;
      this.cellPhoneForm.controls['isOptInForCommunication'].setValue(
        this.optInStatus,
      );
      this.cellPhoneForm.controls[
        'isOptInForCommunication'
      ].updateValueAndValidity();
    }

    if (this.isAllowEdit) {
      this.cellPhoneForm.controls['cellPhoneNumber'].enable();
      if (
        this.originalCellPhoneNumber != null &&
        this.originalCellPhoneNumber != ''
      ) {
        this.cellPhoneForm.controls['isOptInForCommunication'].enable();
      }
    } else {
      this.cellPhoneForm.controls['cellPhoneNumber'].disable();
      this.cellPhoneForm.controls['isOptInForCommunication'].disable();
    }

    this.GetStylingDetails();
  }

  SetValueForCommunication(value: any) {
    this.isCellVerified = false;
    this.CheckCellPhoneNumberValidation(value);
    this.CheckInValidCellPhoneNumber();
    this.cellPhoneForm.get('isOptInForCommunication')?.setValue(null);
    this.cellPhoneForm.get('isOptInForCommunication')?.disable();
  }

  CheckCellPhoneNumberValidation(event: any) {
    this.isCellPhoneNumberValid =
      event && event.replaceAll('-', '').length >= 10;
  }

  CheckInValidCellPhoneNumber() {
    const cellPhoneNumber =
      this.cellPhoneForm.controls['cellPhoneNumber'].value;
    return (
      cellPhoneNumber?.replaceAll('-', '').length > 10 ||
      !this.cellPhoneNumberPattern.test(cellPhoneNumber)
    );
  }

  handlePhoneHash(event: any) {
    this.isCellVerified = true;
    this.cellPhoneForm.get('isOptInForCommunication')?.setValue(true);
    this.cellPhoneForm.get('isOptInForCommunication')?.enable();
    this.cellVerification.emit({
      phoneHash: event,
      isValid: event ? true : false,
    });
  }

  OpenOTPModal() {
    this.isShowOTPModal = true;
    this.cellPhoneNumber = this.cellPhoneForm.controls['cellPhoneNumber'].value;
  }

  HandleCloseModal() {
    this.isShowOTPModal = false;
  }

  GetCellPhoneInfos() {
    this.generalService
      .GetTextsAsync(
        `${TextKeyConstants.CellPhoneInfo},${TextKeyConstants.OptInOptOutInfo}`,
      )
      .then((data: any) => {
        this.CellPhoneInfo = data.find(
          (x: any) => x.textKey === TextKeyConstants.CellPhoneInfo,
        )?.textValue;
        this.OptInOptOutInfo = data.find(
          (x: any) => x.textKey === TextKeyConstants.OptInOptOutInfo,
        )?.textValue;
        this.cdr.detectChanges();
      });
  }

  GetStylingDetails() {
    const pageStyles: { [key: string]: { [key: string]: string } } = {
      'Portal Registration': {
        form: 'd-flex w-100',
        inputdiv: 'n-input-group w370 gap75',
        input: this.classes.item2,
        radio: 'w-100 gap75',
      },
      PA: {
        form: this.classes.item1,
        inputdiv: this.classes.item3,
        input: this.classes.item4,
        radio: this.classes.item3,
      },
      'ACH Contact': {
        form: this.classes.item1,
        inputdiv: this.classes.item3,
        input: this.classes.item2,
        radio: this.classes.item3,
      },
      'ACH Operator': {
        form: this.classes.item1,
        inputdiv: this.classes.item3,
        input: this.classes.item4,
        radio: this.classes.item3,
      },
      'My Profile': {
        form: 'grid-container',
        inputdiv: 'n-input-group w-100',
        input: 'mt-1 ' + this.classes.item2,
        radio: 'mt-1 w-100',
      },
      UserManagement: {
        form: this.classes.item1,
        inputdiv: this.classes.item5,
        input: this.classes.item2,
        radio: this.classes.item5,
      },
    };

    this.componentClasses = pageStyles[this.pageName];
  }

  cellPhoneFormatter(number: string) {
    let cellPhoneNumber = number;
    cellPhoneNumber = cellPhoneNumber.replace(/\D/g, '');
    cellPhoneNumber = cellPhoneNumber.replace(
      /(\d{3})(\d{3})(\d{4})/,
      '$1-$2-$3',
    );
    return cellPhoneNumber;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
